import { useQuery } from "@tanstack/react-query";
import apiClient from "@/services/api/client";
import { API_ENDPOINTS } from "@/services/api/endpoints";

const SSO_STATUS_KEY = ["system-sso", "status"] as const;

export const useSystemSsoStatus = () => {
  return useQuery({
    queryKey: SSO_STATUS_KEY,
    queryFn: async (): Promise<{ sso_enabled: boolean }> => {
      const { data } = await apiClient.get(API_ENDPOINTS.SSO.SYSTEM_STATUS);
      return data;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
};
